export const footerMoreLinks = {
  'us-en': [
    {
      title: 'More',
      items: [
        { title: 'Contact', href: 'https://www.wingie.com/contact/' },
        {
          title: 'Frequently Asked Questions',
          href: 'https://www.wingie.com/faq/',
        },

        { title: 'About us', href: 'https://www.wingie.com/about-us/' },
        { title: 'Privacy', href: 'https://www.wingie.com/privacy/' },
        {
          title: 'Terms and Conditions',
          href: 'https://www.wingie.com/terms-and-conditions/',
        },
        {
          title: 'Our Awards',
          href: 'https://www.wingie.com/awards/',
        },
      ],
    },
  ],
  'us-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://www.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://www.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },

        {
          href: 'https://www.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://www.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://www.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://www.wingie.com/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'us-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://www.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://www.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },

        {
          href: 'https://www.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://www.wingie.com/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://www.wingie.com/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://www.wingie.com/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'us-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://www.wingie.com/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://www.wingie.com/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },

        {
          href: 'https://www.wingie.com/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://www.wingie.com/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://www.wingie.com/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://www.wingie.com/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'us-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://www.wingie.com/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://www.wingie.com/ar/faq/',
          title: 'الأسئلة المتكررة',
        },

        {
          href: 'https://www.wingie.com/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://www.wingie.com/ar/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://www.wingie.com/ar/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://www.wingie.com/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'us-it': [
    {
      title: 'Di più',
      items: [
        { title: 'Contatto', href: 'https://www.wingie.com/it/contact/' },
        // { title: 'Domande frequenti', href: 'https://www.wingie.com/it/faq/' },

        { title: 'Chi siamo', href: 'https://www.wingie.com/it/about-us/' },
        { title: 'Privacy', href: 'https://www.wingie.com/it/privacy/' },
        { title: 'Termini e condizioni', href: 'https://www.wingie.com/it/terms-and-conditions/' },
        { title: 'I nostri premi', href: 'https://www.wingie.com/it/awards/' },
      ],
    },
  ],
  'us-fr': [
    {
      title: 'Plus',
      items: [
        { title: 'Contact', href: 'https://www.wingie.com/fr/contact/' },
        // { title: 'Questions fréquemment posées', href: 'https://www.wingie.com/fr/faq/' },

        { title: 'À propos de nous', href: 'https://www.wingie.com/fr/about-us/' },
        { title: 'Confidentialité', href: 'https://www.wingie.com/fr/privacy/' },
        { title: 'Termes et conditions', href: 'https://www.wingie.com/fr/terms-and-conditions/' },
        { title: 'Nos récompenses', href: 'https://www.wingie.com/fr/awards/' },
      ],
    },
  ],
  'us-pt': [
    {
      title: 'Mais',
      items: [
        { title: 'Contacto', href: 'https://www.wingie.com/pt/contact/' },
        // { title: 'Perguntas frequentes', href: 'https://www.wingie.com/pt/faq/' },

        { title: 'Sobre nós', href: 'https://www.wingie.com/pt/about-us/' },
        { title: 'Privacidade', href: 'https://www.wingie.com/pt/privacy/' },
        { title: 'Termos e condições', href: 'https://www.wingie.com/pt/terms-and-conditions/' },
        { title: 'Os nossos prémios', href: 'https://www.wingie.com/pt/awards/' },
      ],
    },
  ],
  'us-ro': [
    {
      title: 'Mai mult',
      items: [
        { title: 'Contact', href: 'https://www.wingie.com/ro/contact/' },
        // { title: 'Întrebări frecvente', href: 'https://www.wingie.com/ro/faq/' },

        { title: 'Despre noi', href: 'https://www.wingie.com/ro/about-us/' },
        { title: 'Confidențialitate', href: 'https://www.wingie.com/ro/privacy/' },
        { title: 'Termeni și condiții', href: 'https://www.wingie.com/ro/terms-and-conditions/' },
        { title: 'Premiile noastre', href: 'https://www.wingie.com/ro/awards/' },
      ],
    },
  ],
  'us-pl': [
    {
      title: 'Więcej',
      items: [
        { title: 'Kontakt', href: 'https://www.wingie.com/pl/contact/' },
        // { title: 'Często zadawane pytania', href: 'https://www.wingie.com/pl/faq/' },

        { title: 'O nas', href: 'https://www.wingie.com/pl/about-us/' },
        { title: 'Prywatność', href: 'https://www.wingie.com/pl/privacy/' },
        { title: 'Warunki użytkowania', href: 'https://www.wingie.com/pl/terms-and-conditions/' },
        { title: 'Nasze nagrody', href: 'https://www.wingie.com/pl/awards/' },
      ],
    },
  ],
  'us-lt': [
    {
      title: 'Daugiau',
      items: [
        { title: 'Kontaktai', href: 'https://www.wingie.com/lt/contact/' },
        // { title: 'Dažnai užduodami klausimai', href: 'https://www.wingie.com/lt/faq/' },

        { title: 'Apie mus', href: 'https://www.wingie.com/lt/about-us/' },
        { title: 'Privatumas', href: 'https://www.wingie.com/lt/privacy/' },
        { title: 'Taisyklės ir sąlygos', href: 'https://www.wingie.com/lt/terms-and-conditions/' },
        { title: 'Mūsų apdovanojimai', href: 'https://www.wingie.com/lt/awards/' },
      ],
    },
  ],
  'us-uz': [
    {
      title: "Ko'proq",
      items: [
        { title: 'Aloqa', href: 'https://www.wingie.com/uz/contact/' },
        // { title: 'Tez-tez beriladigan savollar', href: 'https://www.wingie.com/uz/faq/' },

        { title: 'Biz haqimizda', href: 'https://www.wingie.com/uz/about-us/' },
        { title: 'Maxfiylik', href: 'https://www.wingie.com/uz/privacy/' },
        { title: 'Shartlar va qoidalar', href: 'https://www.wingie.com/uz/terms-and-conditions/' },
        { title: 'Bizning mukofotlarimiz', href: 'https://www.wingie.com/uz/awards/' },
      ],
    },
  ],
  'us-sr': [
    {
      title: 'Više',
      items: [
        { title: 'Kontakt', href: 'https://www.wingie.com/sr/contact/' },
        // { title: 'Često postavljana pitanja', href: 'https://www.wingie.com/sr/faq/' },

        { title: 'O nama', href: 'https://www.wingie.com/sr/about-us/' },
        { title: 'Privatnost', href: 'https://www.wingie.com/sr/privacy/' },
        { title: 'Uslovi korišćenja', href: 'https://www.wingie.com/sr/terms-and-conditions/' },
        { title: 'Naše nagrade', href: 'https://www.wingie.com/sr/awards/' },
      ],
    },
  ],
  'us-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        { title: 'Байланыш', href: 'https://www.wingie.com/ky/contact/' },
        // { title: 'Көп берилүүчү суроолор', href: 'https://www.wingie.com/ky/faq/' },

        { title: 'Биз жөнүндө', href: 'https://www.wingie.com/ky/about-us/' },
        { title: 'Купуялык', href: 'https://www.wingie.com/ky/privacy/' },
        { title: 'Эрежелер жана шарттар', href: 'https://www.wingie.com/ky/terms-and-conditions/' },
        { title: 'Биздин сыйлыктар', href: 'https://www.wingie.com/ky/awards/' },
      ],
    },
  ],
  'us-tg': [
    {
      title: 'Бештар',
      items: [
        { title: 'Алоқа', href: 'https://www.wingie.com/tg/contact/' },
        // { title: 'Савол-ҷавобҳои зиёд', href: 'https://www.wingie.com/tg/faq/' },

        { title: 'Дар бораи мо', href: 'https://www.wingie.com/tg/about-us/' },
        { title: 'Махфият', href: 'https://www.wingie.com/tg/privacy/' },
        { title: 'Шартҳо ва қоидаҳо', href: 'https://www.wingie.com/tg/terms-and-conditions/' },
        { title: 'Мукофотҳои мо', href: 'https://www.wingie.com/tg/awards/' },
      ],
    },
  ],
  'us-kk': [
    {
      title: 'Көбірек',
      items: [
        { title: 'Байланыс', href: 'https://www.wingie.com/kk/contact/' },
        // { title: 'Жиі қойылатын сұрақтар', href: 'https://www.wingie.com/kk/faq/' },

        { title: 'Біз туралы', href: 'https://www.wingie.com/kk/about-us/' },
        { title: 'Құпиялылық', href: 'https://www.wingie.com/kk/privacy/' },
        { title: 'Ережелер мен шарттар', href: 'https://www.wingie.com/kk/terms-and-conditions/' },
        { title: 'Біздің марапаттар', href: 'https://www.wingie.com/kk/awards/' },
      ],
    },
  ],
  'us-nl': [
    {
      title: 'Meer',
      items: [
        { title: 'Contact', href: 'https://www.wingie.com/nl/contact/' },
        // { title: 'Veelgestelde vragen', href: 'https://www.wingie.com/nl/faq/' },

        { title: 'Over ons', href: 'https://www.wingie.com/nl/about-us/' },
        { title: 'Privacy', href: 'https://www.wingie.com/nl/privacy/' },
        { title: 'Algemene voorwaarden', href: 'https://www.wingie.com/nl/terms-and-conditions/' },
        { title: 'Onze onderscheidingen', href: 'https://www.wingie.com/nl/awards/' },
      ],
    },
  ],
  'us-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://www.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://www.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://www.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://www.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://www.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://www.wingie.com/ja/awards/' },
      ],
    },
  ],
  'us-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://www.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://www.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://www.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://www.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://www.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://www.wingie.com/zh/awards/' },
      ],
    },
  ],
  'us-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://www.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://www.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://www.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://www.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://www.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://www.wingie.com/ko/awards/' },
      ],
    },
  ],
  'us-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://www.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://www.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://www.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://www.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://www.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://www.wingie.com/hi/awards/' },
      ],
    },
  ],
  'us-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://www.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://www.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://www.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://www.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://www.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://www.wingie.com/ta/awards/' },
      ],
    },
  ],
  'us-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://www.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://www.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://www.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://www.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://www.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://www.wingie.com/th/awards/' },
      ],
    },
  ],
  'us-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://www.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://www.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://www.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://www.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://www.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://www.wingie.com/ur/awards/' },
      ],
    },
  ],
  'us-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://www.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://www.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://www.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://www.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://www.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://www.wingie.com/ka/awards/' },
      ],
    },
  ],
}
